/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Toast_UnarchivedInputs */



/**
* | output |
* | --- |
* | "Space restored to your list." |
*
* @param {Spaces_Toast_UnarchivedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_toast_unarchived = /** @type {((inputs?: Spaces_Toast_UnarchivedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Toast_UnarchivedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Space in Ihre Liste zurückgeholt.")
	return /** @type {LocalizedString} */ ("Space restored to your list.")
});